<custom-domain-banner>
    <div if="{state.visible}" class="mx-4 mt-3 mb-2 print:hidden">
        <div class="flex items-center gap-3 px-5 py-3 rounded-lg border-s-4 border-primary bg-primary/5 shadow-sm">
            <span class="text-sm">💡</span>
            <div class="flex-1 text-sm">
                <span class="font-semibold">{locale?.t('domainbanner_title')}</span>
                <span class="font-mono font-bold ms-1">{state.domain}</span>
                <span class="text-gray-500 ms-1 hidden sm:inline">— {locale?.t('domainbanner_benefit')}</span>
            </div>
            <div class="flex items-center gap-1">
                <button class="btn btn-ghost btn-xs" onclick="{copyDomain}" title="{locale?.t('idp_guide_copy')}" aria-label="{locale?.t('idp_guide_copy')}">
                    <i class="icon-metalark-copy"></i>
                </button>
                <a href="https://{state.domain}" target="_blank" class="btn btn-ghost btn-xs hidden sm:flex" title="{locale?.t('domainbanner_bookmark')}">
                    <i class="icon-metalark-link"></i>
                </a>
                <button class="btn btn-ghost btn-xs opacity-50" onclick="{dismiss}" aria-label="{locale?.t('dismiss')}">
                    <i class="icon-metalark-x"></i>
                </button>
            </div>
        </div>
    </div>

    <script>
        import { getApi, getIdentityProviderService } from '../services/service-loader';
        import { getSubdomainUrl } from '../utils/domain';

        export default {
            state: {
                visible: false,
                domain: null,
            },

            async onMounted() {
                await this.checkShouldShow();
            },

            async checkShouldShow() {
                try {
                    // Don't show if already on a custom subdomain
                    const hostname = window.location.hostname;
                    const parts = hostname.split('.');
                    if (parts.length >= 3 && !['www', 'app', 'localhost'].includes(parts[0])) {
                        return; // Already on custom domain
                    }

                    // Need user context to know the customer
                    const userContext = await this.tools.getUserContext();
                    if (!userContext?.customerId) return;

                    // Check if already dismissed for this customer
                    const dismissKey = `domainbanner_dismissed_${userContext.customerId}`;
                    if (localStorage.getItem(dismissKey)) return;

                    // Check if customer has a custom domain
                    const api = await getApi();
                    let subdomains;
                    try {
                        // skipLoading: a banner that renders on every page and hides
                        // itself when there is nothing to show — the catch below returns
                        // silently. It has no business blocking the application.
                        const resp = await api.get('/subdomains', { skipLoading: true });
                        subdomains = (resp.data?.subdomains || []).filter(s => s.status === 'ACTIVE');
                    } catch {
                        return; // No subdomain endpoint or no access
                    }

                    if (subdomains.length === 0) return;

                    // Check if customer has at least one SSO provider configured
                    const idpService = await getIdentityProviderService();
                    let hasProvider = false;
                    try {
                        const resp = await idpService.get({ customerId: userContext.customerId });
                        const providers = resp.identityProviders || [];
                        hasProvider = providers.some(p => p.enabled && p.type !== 'COGNITO_NATIVE');
                    } catch {
                        return;
                    }

                    if (!hasProvider) return;

                    // Show the banner
                    const subdomain = subdomains[0];
                    const fullUrl = getSubdomainUrl(subdomain.subdomain);
                    this.update({
                        visible: true,
                        domain: fullUrl.replace('https://', ''),
                        customerId: userContext.customerId,
                    });
                } catch (err) {
                    console.warn('[CustomDomainBanner] Check failed:', err);
                }
            },

            copyDomain() {
                navigator.clipboard.writeText(`https://${this.state.domain}`);
                // Brief visual feedback
                const btn = this.root.querySelector('.icon-metalark-copy')?.parentElement;
                if (btn) {
                    btn.classList.add('btn-success');
                    setTimeout(() => btn.classList.remove('btn-success'), 1000);
                }
            },

            dismiss() {
                const dismissKey = `domainbanner_dismissed_${this.state.customerId}`;
                localStorage.setItem(dismissKey, 'true');
                this.update({ visible: false });
            },
        };
    </script>
</custom-domain-banner>
